import React from 'react';
import {Link} from 'react-router-dom';
import Logo from '../assets/images/Navigation.png';

export default function ErrorPage() {
  return (
    <div className="errorpage-section">
      <div className="container-fluid">
        <div className="heading-sec">
          <div className="row text-center pt-2">
            <div className="col">
              <div className="logo">
                <a href="/">
                  <img src={Logo} alt="logo-img" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="errorpage-form-section">
          <div className="row">
            <div className="col">
              <div className="errorpage-form">
                <div className="row">
                  <div className="col p-0">
                    <div className="form-card ">
                      <div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
                        <div className="page-error-content error404Container">
                          <h1 className="error-code animated zoomInDown error404">404</h1>
                          <p className="text-center fw-regular title bounceIn animation-delay-10 animated error404Text">
                            We are sorry, the page you are looking for is not found.
                          </p>
                          <div className="text-center zoomIn animation-delay-20 animated login-btn">
                            <Link to="/account-summary" className="primary">
                              Go to Dashboard Page
                            </Link>
                          </div>
                          {/* <ThemeSwitcher /> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
